import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HttpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"http"}/>
}
